import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { fetchMapProjects } from "@store/projects-map/projects-map-thunks";
import { deleteProject, updateProjectDetails } from "@store/projects/projects-slice-thunk";
import { convertProjectTypesToSdbProject, restoreMissingProjectFields } from "@store/projects/projects-slice-utils";
/** Redux entity adapter for the projects map slice */
export const projectsMapAdapter = createEntityAdapter({
  selectId: project => project.id
});
const initialState = {
  ...projectsMapAdapter.getInitialState(),
  fetchingStatus: "uninitialized"
};
const projectsMapSlice = createSlice({
  name: "projectsMap",
  initialState,
  reducers: {
    /** Adds a newly created project to the map project state */
    addCreatedProject: (state, action) => {
      projectsMapAdapter.addOne(state, action.payload);
    },
    /** Resets the projects state */
    resetProjectsMapState: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchMapProjects.pending, state => {
      state.fetchingStatus = "pending";
    }).addCase(fetchMapProjects.fulfilled, (state, action) => {
      projectsMapAdapter.setAll(state, action.payload);
      state.fetchingStatus = "succeeded";
    }).addCase(fetchMapProjects.rejected, state => {
      state.fetchingStatus = "rejected";
    }).addCase(updateProjectDetails.fulfilled, (state, action) => {
      const updatedProject = convertProjectTypesToSdbProject(action.payload);
      const existingProject = projectsMapAdapter.getSelectors().selectById(state, updatedProject.id);
      const restoredProject = restoreMissingProjectFields({
        updatedProject,
        existingProject
      });
      projectsMapAdapter.setOne(state, restoredProject);
    }).addCase(deleteProject.fulfilled, (state, action) => {
      const projectId = action.payload;
      projectsMapAdapter.removeOne(state, projectId);
    });
  }
});
export const {
  addCreatedProject,
  resetProjectsMapState
} = projectsMapSlice.actions;

/** Slice reducer for the projects map */
export const projectsMapReducer = projectsMapSlice.reducer;